import axios from '@/axios.js';

export const productApi = {
  getProducts(payload) {
    return axios.get(`admin/products`, {
      params: payload,
    });
  },
  addProduct(body) {
    return axios.post(`admin/products`, body);
  },
  getProduct(id) {
    return axios.get(`admin/products/${id}?join=belongsTo&join=translations`);
  },
  updateProduct(id, body) {
    return axios.patch(`admin/products/${id}`, body);
  },
  deleteProduct(id) {
    return axios.delete(`admin/products/${id}`);
  },
};
